<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">商户管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="商户编号">
            <el-input v-model="Business_Code" placeholder="请输入商户编号"  :disabled="BusinessCodeDisabled" clearable></el-input>
          </el-form-item>
          <el-form-item label="商户名称">
            <el-input v-model="Business_Name" placeholder="请输入商户名称" clearable></el-input>
          </el-form-item>
           <el-form-item label="商户类型" prop="BusinessTypeId">
              <el-select  filterable placeholder="请选择"  v-model="BusinessType_Id" clearable>
                <el-option
                  v-for="item in BusinessTypes"
                  :key="item.BusinessTypeId"
                  :label="item.BusinessTypeName"
                  :value="item.BusinessTypeId">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="BusinessCode" label="商户编号"></el-table-column>
              <el-table-column prop="BusinessName" label="商户名称"></el-table-column>
              <el-table-column prop="Proportion" label="分账比例(%)"></el-table-column>
               <el-table-column prop="StatusMessage" label="商户状态"></el-table-column>
              <el-table-column prop="Description" label="备注">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="备注" width="250" trigger="hover">
                    <div>{{scope.row.Description}}</div>
                    <span
                      slot="reference"
                    >{{ (scope.row.Description!=null &&scope.row.Description.length>15)?scope.row.Description.substr(0,15)+'...':scope.row.Description }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="320" align="center">
                <template slot-scope="scope">
                  <el-button 
                    @click="qrCodeClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >二维码</el-button>
                  <el-button v-if="scope.row.IsSyncToNH=='1' && scope.row.isPassed!='1'"
                    @click="reviewClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >提交审核</el-button>
                  <el-button
                    @click="QrySubClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >获取状态</el-button>
                  <el-button  v-if="LoginIsMain=='1'"
                    @click="OpenClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >开启</el-button>
                  <el-button  v-if="LoginIsMain=='1'"
                    @click="CloseClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >关闭</el-button>
                  <el-button  v-if="LoginIsMain=='1'"
                    @click="RescindClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >解约</el-button>
                   <el-button v-if="scope.row.IsSyncToNH=='1' && scope.row.isPassed!='1' "
                    @click="VerifySubClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >商户验证</el-button>
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button  v-if="LoginIsMain=='1'" @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button v-if="scope.row.isPassed!='1'  && LoginIsMain=='1'"
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <BusinessInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :Business_Id="SelectedBusinessId"
        :IsEdit="IsEdit"
        :IsFinish="IsFinish"
      ></BusinessInfoPage>
    </ZjDialog>
     <ZjDialog
      :title="QRconfig.title"
      :dialogFormVisible="QRconfig.dialogFormVisible"
      :width="QRconfig.width"
      :height="QRconfig.height"
      @clickCancel="handleQRDialogCancel"
    >
      <QRCodePage
        @clickCancel="handleQRDialogCancel"
        :Business_Code="SelectBusiness_Code"
        :ChildBusiness_Code="SelectChildBusiness_Code"
      ></QRCodePage>
    </ZjDialog>
     <ZjDialog
      :title="Verifyconfig.title"
      :dialogFormVisible="Verifyconfig.dialogFormVisible"
      :width="Verifyconfig.width"
      :height="Verifyconfig.height"
      @clickCancel="handleVerifyDialogCancel"
    >
      <VerifyPage
        @clickOk="handleVerifyDialogOk"
        @clickCancel="handleVerifyDialogCancel"
        :Business_Code="SelectBusiness_Code"
        :Business_Name="SelectBusiness_Name"
        :Business_Account="SelectBusiness_Account"
      ></VerifyPage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import BusinessInfoPage from "./businessinfo.vue";
import QRCodePage from "./QRCode.vue";
import VerifyPage from "./businessverify.vue";

export default {
  name: "BusinessPage",
  controller: "UI",
  action: "Businesses",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      Business_Code: "",
      BusinessCodeDisabled:false,
      Business_Name: "",
      LoginBusiness:"",
      LoginIsMain:"0",
      BusinessType_Id:"",
      SelectBusiness_Code:"",
      SelectBusiness_Name:"",
      SelectBusiness_Account:"",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "添加商户",
        dialogFormVisible: false,
        width: "1200px",
      },
      QRconfig:{
        title:"二维码",
        dialogFormVisible: false,
         width: "370px",
         height:"400px"
      },
      Verifyconfig:{
        title:"打款验资",
        dialogFormVisible: false,
        width: "600px",
        height:"400px"
      },
      multipleSelection: [],
      IsEdit: true,
      IsFinish:false,
      BusinessTypes:[]
    };
  },
  components: {
    BusinessInfoPage,
    QRCodePage,
    VerifyPage
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.GetBusinessType();
    this.init();
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.GetBusinesses();
    this.logInfo.ActionName = "商户管理查看";
    this.logInfo.LogMessage = "商户管理查看";
    this.logInfo.ModuleName = "统一管理";
    this.logInfo.PageName = "商户信息";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    // 初始化
    init() {
      return utils.waitAll([
        ()=>this.GetLoginBusiness(),
        () => this.GetBusinesses()]);
    },
    GetBusinessType()
    {
      return new WebApis.BusinessTypeApi().FindAll().then((res)=>{
          if (res.data.Data) {
              this.BusinessTypes=res.data.Data;
          }
       });
    },
    GetLoginBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
        this.Business_Code=user.LoginName;
        this.BusinessCodeDisabled=true;
      }
      else
      {
        this.Business_Code="";
        this.BusinessCodeDisabled=false;
        this.LoginIsMain="1";
      }

       

      if(this.Business_Code!="" && this.Business_Code!=null )
      {
        let BusinessSearch={
          BusinessCode: this.Business_Code
        }

      return new WebApis.BusinessApi()
        .GetItemByBusinessCode(BusinessSearch)
        .then((res)=>{
            console.log("商户信息",res);
            this.LoginBusiness = res.data.Data;
            this.LoginIsMain=this.LoginBusiness.IsMain;

            if(this.LoginIsMain=="1")
            {
              this.Business_Code="";
              this.BusinessCodeDisabled=false;
            }
        });
      }
    },
    GetBusinesses() {
      showLoading(".zj-table-container");

      let BusinessSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        BusinessCode: this.Business_Code!=""?this.Business_Code:null,
        BusinessName: this.BusinessName!=""?this.BusinessName:null,
        BusinessTypeId:this.BusinessType_Id!=""?this.BusinessType_Id:null,
        TotalCount: 0,
      };

      console.log(BusinessSearch);
      return new WebApis.BusinessApi()
        .GetPageContentByConditions(BusinessSearch)
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage=1;
      this.GetBusinesses();
    },
    clearsearch() {
      this.Business_Code = "";
      this.Business_Name = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.GetBusinesses();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBusinesses();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetBusinesses();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    onAdd() {
      this.SelectedBusinessId = "";
      this.IsEdit = true;
      this.IsFinish=false;
      this.dilaogconfig.dialogFormVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    //已维护在组织机构中，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        new WebApis.OrgApi()
          .GetItemById({
            OrgId: selectData[i].BusinessId,
          })
          .then((r) => {
            var data = r.data.Data;
            if (data!=null) {
              this.$message.error(
                selectData[i].BusinessName + "已维护在组织机构中，不能删除"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch((e) => {
            console.log(e);
            this.$message({
              showClose: true,
              message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
              type: "error",
            });
          });
      }
    },
    onbatchDel() {
      let Business_Ids = [];
      this.multipleSelection.forEach((item) => {
        Business_Ids.push(item.BusinessId);
      });

      if (Business_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定删除选中商户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let BusinessSearch = {
          BusinessIds: Business_Ids,
        };
        console.log(BusinessSearch);
        const that = this;
        that.canDelete(that.multipleSelection, function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index == -1 && data.length == Business_Ids.length) {
            new WebApis.BusinessApi()
              .DelItemList(BusinessSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetBusinesses();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "商户删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "商户删除成功" : "删除商户失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "商户管理列表页面";
                that.addOperationLog();
              })
              .catch((e) => {
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取商户信息失败!",
                  type: "error",
                });
              });
          } else {
            return;
          }
        });
      });
    },
    queryClick(index, row) {
      this.SelectedBusinessId = row.BusinessId;
      this.IsEdit = false;
      this.IsFinish = false;
      this.dilaogconfig.title = "查看商户";
      this.dilaogconfig.dialogFormVisible = true;
    },
    editClick(index, row) {
      this.SelectedBusinessId = row.BusinessId;
      this.IsEdit = true;
      this.IsFinish = false;
      this.dilaogconfig.title = "修改商户";
      this.dilaogconfig.dialogFormVisible = true;
    },
    qrCodeClick(index, row) {
      this.SelectBusiness_Code = row.BusinessCode;
      this.SelectChildBusiness_Code= row.ChildBusinessCode;
      this.QRconfig.title = "二维码";
      this.QRconfig.dialogFormVisible = true;
    },
    reviewClick(index, row) {
      this.SelectedBusinessId = row.BusinessId;
      this.IsEdit = false;
      this.IsFinish = true;
      this.dilaogconfig.title = "提交审核";
      this.dilaogconfig.dialogFormVisible = true;
    },
    VerifySubClick(index, row){
      this.SelectBusiness_Code = row.BusinessCode;
      this.SelectBusiness_Name = row.BusinessName;
      this.SelectBusiness_Account = row.Account;
      this.Verifyconfig.title = "验资打款";
      this.Verifyconfig.dialogFormVisible = true;
    },
    QrySubClick(index, row) {
      
      const that = this;

      this.SelectBusiness_Code = row.BusinessCode;
      
      that.GetBusiessStatus(this.SelectBusiness_Code);
    },
    GetBusiessStatus(thisBusinessCode) {
      
      const that = this;
      
      let QrySubMerchantInfo={
        SubMerId:thisBusinessCode
      }


       new WebApis.BusinessApi()
          .QrySubMerchantInfoService(QrySubMerchantInfo)
          .then((r)=>{
            console.log("获取状态",r);
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "获取状态成功!" });
                  this.GetBusinesses();
                }
                else{
                  that.$message({ type: "success", message: "获取状态失败!" });
                }
          }).catch((e)=>{
            console.log("获取状态失败",e);
            that.$message({
                    showClose: true,
                    message: e ? "获取状态失败!" + e.RspMsg : "获取状态失败!",
                    type: "error",
                  });
          });
    },
    CloseClick(index, row)
    {
        const that = this;

      this.SelectBusiness_Code = row.BusinessCode;
    
     this.$confirm("确定关闭该商家?关闭后无法开启，需要解约后重新提交申请", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      
          let UpdateSubMerchantStatus={
            SubMerId:row.BusinessCode,
            UpdateFlag:'5'
          }


          new WebApis.BusinessApi()
              .UpdateSubMerchantStatusService(UpdateSubMerchantStatus)
              .then((r)=>{
                console.log("关闭",r);
                    if (r.RspCode == "1") {
                    if(r.data.Data.Status==0)
                      {
                        this.$message({ type: "success", message: "关闭成功!" });
                        
                        this.GetBusiessStatus(this.SelectBusiness_Code);
                      }
                      else if(r.data.Data.Status==1)
                      {
                        this.$message({
                          showClose: true,
                          message: r.data.Data.Response.Msg,
                          type: "error",
                        });
                        
                        return false;
                      }
                    }
                    else{
                      that.$message({ type: "success", message: "关闭失败!" });
                    }
              }).catch((e)=>{
                console.log("关闭失败",e);
                that.$message({
                        showClose: true,
                        message: e ? "关闭失败!" + e.RspMsg : "关闭失败!",
                        type: "error",
                      });
              });
        });
    },
    OpenClick(index, row)
    {
        const that = this;

      this.SelectBusiness_Code = row.BusinessCode;

      this.$confirm("确定开启该商家?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      
          let UpdateSubMerchantStatus={
            SubMerId:row.BusinessCode,
            UpdateFlag:'6'
          }


          new WebApis.BusinessApi()
              .UpdateSubMerchantStatusService(UpdateSubMerchantStatus)
              .then((r)=>{
                console.log("开启",r);
                    if (r.RspCode == "1") {
                      if(r.data.Data.Status==0)
                      {
                        that.$message({ type: "success", message: "开启成功!" });
                        
                        this.GetBusiessStatus(this.SelectBusiness_Code);
                      }
                      else if(r.data.Data.Status==1)
                      {
                        this.$message({
                          showClose: true,
                          message: r.data.Data.Response.Msg,
                          type: "error",
                        });
                        
                        return false;
                      }
                    }
                    else{
                      that.$message({ type: "success", message: "开启失败!" });
                    }
              }).catch((e)=>{
                console.log("开启失败",e);
                that.$message({
                        showClose: true,
                        message: e ? "开启失败!" + e.RspMsg : "开启失败!",
                        type: "error",
                      });
              });
        });
    },
    RescindClick(index, row)
    {
        const that = this;

      this.SelectBusiness_Code = row.BusinessCode;

      this.$confirm("确定解约该商家?解约后无法开启，需要重新提交申请", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
      
          let UpdateSubMerchantStatus={
            SubMerId:row.BusinessCode,
            UpdateFlag:'4'
          }


          new WebApis.BusinessApi()
              .UpdateSubMerchantStatusService(UpdateSubMerchantStatus)
              .then((r)=>{
                console.log("解约",r);
                    if (r.RspCode == "1") {
                      if(r.data.Data.Status==0)
                      {
                        that.$message({ type: "success", message: "解约成功!" });
                        
                        this.GetBusiessStatus(this.SelectBusiness_Code);
                      }
                      else if(r.data.Data.Status==1)
                      {
                        this.$message({
                          showClose: true,
                          message: r.data.Data.Response.Msg,
                          type: "error",
                        });
                        
                        return false;
                      }
                    }
                    else{
                      that.$message({ type: "success", message: "解约失败!" });
                    }
              }).catch((e)=>{
                console.log("解约失败",e);
                that.$message({
                        showClose: true,
                        message: e ? "解约失败!" + e.RspMsg : "解约失败!",
                        type: "error",
                      });
              });
        });
    },
    deleteClick(index, row) {
      this.SelectedBusinessId = row.BusinessId;
      this.$confirm("确定删除该商家?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let BusinessSearch = {
          BusinessId: this.SelectedBusinessId,
        };
        const that = this;
        that.canDelete([row], function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index != -1) {
            return;
          } else {
            new WebApis.BusinessApi()
              .DelItem(BusinessSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetBusinesses();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "商户删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "商户删除成功" : "删除商户失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "商户列表";
                that.addOperationLog();
              })
              .catch((e) => {
                console.log(e);
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取产品信息失败!",
                  type: "error",
                });
              });
          }
        });
      });
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetBusinesses();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    handleQRDialogCancel() {
      this.QRconfig.dialogFormVisible = false;
    },
    handleVerifyDialogOk() {
      this.Verifyconfig.dialogFormVisible = false;
      this.GetBusinesses();
    },
    handleVerifyDialogCancel(){
      this.Verifyconfig.dialogFormVisible=false;
    }
  },
};
</script>